import ro from '../../i18n/locales/opportunities.ro'
import en from '../../i18n/locales/opportunities.en'
import ru from '../../i18n/locales/opportunities.ru'

export type OpportunityCopy = {
  home: {
    title: string
    intro: string
    crmTitle: string
    crmText: string
    erpTitle: string
    erpText: string
    automationTitle: string
    automationText: string
    link: string
  }
  services: {
    aiLink: string
    crmLink: string
    devopsTitle: string
    devopsIntro: string
    hostingTitle: string
    hostingText: string
    operationsTitle: string
    operationsText: string
    slaTitle: string
    slaText: string
    seoTitle: string
    seoIntro: string
    seoDeliverablesTitle: string
    seoDeliverables: string[]
    seoResultsTitle: string
    seoResultsText: string
    seoMeasureTitle: string
    seoMeasureText: string
    marketingTitle: string
    marketingText: string
  }
  portfolio: {
    processTitle: string
    processIntro: string
    steps: { title: string, text: string }[]
    casesTitle: string
    casesText: string
    casesLink: string
  }
  faqLink: string
  calculatorLink: string
}

export const opportunityCopy: Record<'ro' | 'en' | 'ru', OpportunityCopy> = { ro, en, ru }
